/* Cabal · agregar rutina completa */
document.addEventListener('click',function(e){
  var btn=e.target.closest('[data-cs-add-many]');if(!btn)return;e.preventDefault();
  var ids=(btn.dataset.csAddMany||'').split(',').filter(Boolean);if(!ids.length)return;
  var label=btn.textContent;btn.classList.add('is-loading');btn.textContent='Agregando…';
  var d=document.querySelector('cart-drawer');
  var body={items:ids.map(function(id){return{id:Number(id),quantity:1}})};
  if(d&&d.getSectionsToRender){body.sections=d.getSectionsToRender().map(function(s){return s.id});body.sections_url=window.location.pathname;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
  .then(function(r){return r.json()}).then(function(res){
    btn.classList.remove('is-loading');
    if(res.status){btn.textContent=res.description||'Algún producto no tiene stock';setTimeout(function(){btn.textContent=label},3000);return;}
    btn.textContent='Rutina agregada';setTimeout(function(){btn.textContent=label},2000);
    if(typeof publish==='function'&&window.PUB_SUB_EVENTS){publish(PUB_SUB_EVENTS.cartUpdate,{source:'cabal-routine',cartData:res});}
    if(d&&res.sections){var item=res.items?res.items[0]:res;item.sections=res.sections;d.renderContents(item);d.classList.remove('is-empty');}
    else{window.location='/cart';}
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){document.querySelectorAll('[data-cs-cart-count]').forEach(function(el){el.textContent=c.item_count})});
  }).catch(function(){btn.classList.remove('is-loading');btn.textContent=label;});
});
